// extracted by mini-css-extract-plugin
export var scrollArea = "_oh-0";